import React, { Component } from "react";

class CustomCheckbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      is_checked: props.isChecked ? true : false
    };

    this.handleClick = this.handleClick.bind(this);
  }
  // componentWillReceiveProps(nextProps) {
  //   if (this.props.isChecked !== nextProps.isChecked) {
  //     this.setState({ is_checked: nextProps.isChecked });
  //   }
  // }

  // componentDidUpdate = (prevProps, prevState) => {

  //   console.log("------------------------------------------------------------------");
  //   console.log("21 - componentDidUpdate= prevProps=", prevProps);
  //   console.log("22 - componentDidUpdate= this.props.isChecked", this.props.isChecked);
  //   console.log("23 - componentDidUpdate= prevState=", prevState);

  //   if (this.props.isChecked !== prevProps.isChecked) {
  //     console.log("26 - SET STATE=", this.props.isChecked);
  //     this.setState({ is_checked: this.props.isChecked });
  //   }
  // };

  static getDerivedStateFromProps = async (props, state) => {
    if (props) {
      state.is_checked = props.isChecked;
    }
  };


  handleClick() {
    const newValue = !this.state.is_checked;
    const ret = this.props.onCheck(newValue);
    
    if (ret !== undefined) {
      this.setState({ is_checked: newValue });
    }
  }

  render() {    
    // const { isChecked, number, label, inline, ...rest } = this.props;
    const { number, label, inline, intable, disabled } = this.props;

    const classes =
      inline !== undefined ? "checkbox checkbox-inline" :
        intable !== undefined ? "checkbox checkbox-intable" : "checkbox";

    return (
      <div className={classes}>
        <input
          disabled={disabled}
          id={number}
          type="checkbox"
          onChange={this.handleClick}
          checked={this.state.is_checked !== null ? this.state.is_checked : false}
        />
        <label htmlFor={number}>{label}</label>
      </div>
    );
  }
}

export default CustomCheckbox;
